// this function is a duplicate from the webserver
// it can be used to check if a user has the permissions
// to perform the given action

const hasPermission = (permissions, action) => {
	// Check for exact match
	if (permissions.includes(action)) {
		return true;
	}

	// Check for wildcard permissions
	const actionParts = action.split(":");
	for (const permission of permissions) {
		const permissionParts = permission.split(":");

		if (permissionParts.length !== actionParts.length) {
			continue;
		}

		let match = true;
		for (let i = 0; i < permissionParts.length; i++) {
			if (permissionParts[i] !== "*" && permissionParts[i] !== actionParts[i]) {
				match = false;
				break;
			}
		}

		if (match) {
			return true;
		}
	}

	return false;
};

module.exports = {
	hasPermission,
};
